import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MortgageOffersHeaderRow.css';

export const MortgageOffersHeaderRow: React.FC = () => {
  return (
    <div className={styles['row']}>
      <div className={styles['main']}>
        <ArticleParagraph2 color="gray40_100">Банки и застройщики</ArticleParagraph2>
      </div>
      <div className={styles['rate']}>
        <ArticleParagraph2 color="gray40_100">Ставка</ArticleParagraph2>
      </div>
      <div className={styles['sum']}>
        <ArticleParagraph2 color="gray40_100">Сумма</ArticleParagraph2>
      </div>
      <div className={styles['term']}>
        <ArticleParagraph2 color="gray40_100">Срок</ArticleParagraph2>
      </div>
      <div className={styles['payment']}>
        <ArticleParagraph2 color="gray40_100">Ежемесячный платёж</ArticleParagraph2>
      </div>
    </div>
  );
};
